module.exports = __webpack_public_path__ + "media/media/favicon/mstile-150x150-7c474bb8de84d4a3a80c4db0dba6a60d.png";